<template>
    <div class="pt-8">
        <filter-form 
            :filter="filter" 
            :tipoDocumento="tipo_documento"
            @get-clientes="getClientes()" 
            @clear-filter-form="clearFilterForm()" 
        />
        
        <clientes-table 
            :clientes="clientes" 
            :paginator="paginator" 
            :pageSize="pageSize" 
            @get-clientes="getClientes()" 
            @change-page="changePage($event)" 
        />
    </div>
</template>
<script>
import ClientesTable from '../components/ClientesTable.vue'
import FilterForm from '../components/FilterForm.vue'
import { mapMutations } from 'vuex'
export default {
    data(){
        return{
            clientes: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
            filter:{
                cliente: "",
                documento: "",
                tipoDocumento: "",
                departamento: "",
                ciudad: ""
            },
            tipo_documento: []
        }
    },
    components: {
        ClientesTable,
        FilterForm
    },
    created(){
        this.getClientes();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getClientes() {
            this.pageOptions = { 
                pageNumber:   this.paginator.page, 
                pageSize:     this.paginator.pageSize,
                tipoDocumento: this.filter.tipoDocumento,
                cliente:      this.filter.cliente,
                documento: this.filter.documento
            }
            this.setLoading(true)
            await this.$conectar.post('clientes/get-all-clientes', this.pageOptions)
            .then(response =>{
                this.clientes = response.data.clientesLists;
                this.paginator.totalPage = response.data.totalPages;
                this.tipo_documento = response.data.tipo_documento;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getClientes();
        },
        clearFilterForm(){
            this.filter.cliente = "";
            this.filter.tipoDocumento = "";
            this.filter.documento = "";
            this.paginator.pageSize = 10;
        },
    }
}
</script>

<style scoped>
.singleLine th {
  white-space: nowrap !important;
  overflow: hidden !important;
}
.singleLineTd td {
  white-space: nowrap !important;
  overflow: hidden !important;
}
</style>